import { ArrowDownTrayIcon, CheckIcon } from "@heroicons/react/20/solid";
import {
  Tabs,
  TabsHeader,
  TabsBody,
  Tab,
  TabPanel,
} from "@material-tailwind/react";
import {
  Square3Stack3DIcon,
  UserCircleIcon,
  Cog6ToothIcon,
} from "@heroicons/react/24/solid";
import React from "react";
import MsingiPoaTabs from "./MsingiPoaTabs";
import { FiArrowDownCircle } from "react-icons/fi";
import CriticalApply from "../../assets/CriticalApply.pdf";
import CriticalClaim from "../../assets/CriticalClaim.pdf";
import Msingi from "../../assets/Msingi.pdf";
import { Link } from "react-router-dom";

export default function MsingiPoa() {
  return (
    <div className="text-ternary-dark dark:text-ternary-light pb-8  ">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto mt-16 max-w-xl rounded-3xl ring-1 ring-gray-200 sm:mt-20 lg:mx-0 lg:flex lg:max-w-none">
          <div className="p-8 sm:p-10 lg:flex-auto">
            <h3 className="text-4xl font-bold tracking-tight">
              Msingi Poa Education Plan
            </h3>
            <p className="mt-6 text-base max-w-lg leading-7 ">
              This plan secures your child'd education Milestones. Imagine if
              your child could access world class education without denting your
              pockets. Imagine if furthering your studies was not such a
              daunting task. Britam’s Msingi Poa makes it so much easier for you
              to finance your education plans and more.
            </p>
            

            <div className="mt-10 flex items-center gap-x-4"></div>
          </div>
          <div className="-mt-2 p-2 lg:mt-0 lg:w-full lg:max-w-3xl pt-2 lg:flex-shrink-0">
          <div className="flex gap-x-4 items-center ">
              <a
                download={CriticalApply}
                href={CriticalApply}
                className="font-general-medium flex justify-center items-center w-36 sm:w-48 mt-12 mb-6 sm:mb-0 text-lg border border-indigo-200 dark:border-ternary-dark py-2.5 sm:py-3 shadow-lg rounded-lg bg-indigo-50 focus:ring-1 focus:ring-indigo-900 hover:bg-indigo-500 text-gray-500 hover:text-white duration-500"
                aria-label="Download Resume"
              >
                <FiArrowDownCircle className="mr-2 sm:mr-3 h-5 w-5 sn:w-6 sm:h-6 duration-100"></FiArrowDownCircle>
                <span className="text-sm sm:text-lg font-general-medium duration-100">
                  Application Form
                </span>
              </a>
              <a
                href={CriticalClaim}
                download={CriticalClaim}
                className="font-general-medium flex justify-center items-center w-36 sm:w-48 mt-12 mb-6 sm:mb-0 text-lg border border-indigo-200 dark:border-ternary-dark py-2.5 sm:py-3 shadow-lg rounded-lg bg-indigo-50 focus:ring-1 focus:ring-indigo-900 hover:bg-indigo-500 text-gray-500 hover:text-white duration-500"
                aria-label="Download Resume"
              >
                <FiArrowDownCircle className="mr-2 sm:mr-3 h-5 w-5 sn:w-6 sm:h-6 duration-100"></FiArrowDownCircle>
                <span className="text-sm sm:text-lg font-general-medium duration-100">
                  Claim Form
                </span>
              </a>
              <a
                href={Msingi}
                download={Msingi}
                className="font-general-medium flex justify-center items-center w-36 sm:w-48 mt-12 mb-6 sm:mb-0 text-lg border border-indigo-200 dark:border-ternary-dark py-2.5 sm:py-3 shadow-lg rounded-lg bg-indigo-50 focus:ring-1 focus:ring-indigo-900 hover:bg-indigo-500 text-gray-500 hover:text-white duration-500"
                aria-label="Download Resume"
              >
                <FiArrowDownCircle className="mr-2 sm:mr-3 h-5 w-5 sn:w-6 sm:h-6 duration-100"></FiArrowDownCircle>
                <span className="text-sm sm:text-lg font-general-medium duration-100">
                  Product Brochure
                </span>
              </a>
            </div>
            <div className="py-8">
            <MsingiPoaTabs />
            </div>
            
          </div>
        </div>
      </div>
    </div>
  );
}
